export default __webpack_public_path__ + "static/media/dashboard_desktop.376e42aa.png";